import React from "react";

function PreparingWorkspace(props) {
  

  return (
    <React.Fragment>
      <div className="container">
        <div className="row">&nbsp;</div>
        <div className="row">&nbsp;</div>
        <div className="alert alert-primary bg-white" role="alert">
          <div className="row">
            <h4 className="alert-heading">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              &nbsp;&nbsp;&nbsp;Welcome. We are preparing or switching your
              workspace
            </h4>
          </div>
          <p>
            Please be patient while we do so. We will take you to your dashboard
            once we are done.
          </p>
          <hr />
          {/* <p className="mb-0">
            If you are the admin , Please visit admin section and associate few
            workspace for the selected workspace or party. Please click&nbsp;
            <a
              style={{ cursor: "pointer" }}
              onClick={() => history.push("admin/dashboard")}
            >
              here
            </a>
            &nbsp;to got to admin side
          </p>
          <br />
          <p className="mb-0">
            If you are lost , Please click&nbsp;
            <a href="/login">here</a>&nbsp;to login back
          </p> */}
        </div>
      </div>
    </React.Fragment>
  );
}

export default PreparingWorkspace;
